module.exports = __webpack_public_path__ + "static/media/PIAS.5940320b.jpg";